<template>
  <section class="bg-amber-100 pb-32 pt-14">
    <Container indent="container-tight relative">
      <Filter
        :terms="blogAndCategories.data?.terms?.data"
        @update="filterUpdate($event)"
      />
      <!-- CARDS -->

      <TransitionGroup
        tag="ul"
        name="list-filter"
        mode="out-in"
        class="relative mt-8 grid grid-cols-1 gap-8 sm:mt-14 sm:gap-12 md:grid-cols-2 lg:gap-y-24"
      >
        <li
          v-for="blogPost in filteredBlog"
          :key="blogPost.id"
          class="inset-0 transition-all md:max-w-[31.25rem]"
        >
          <EntryCard
            :class="`${blogPost.color_theme?.value || 'blue'}-el`"
            :data="blogPost"
          />
        </li>
      </TransitionGroup>

      <!-- NO BLOGPOSTS FOUND -->
      <div v-if="filteredBlog.length === 0" class="mb-14 w-full">
        <p class="text-center">Es wurden leider keine Blogbeiträge gefunden.</p>
      </div>

      <div v-show="hasMorePages" class="my-14 flex w-full justify-end">
        <AppButton @click="loadMore()">Mehr anzeigen</AppButton>
      </div>
    </Container>
  </section>
</template>

<script setup>
import { store } from '/store.js'
const blogAndCategories = ref(null)
const hasMorePages = ref(false)
let limit = 6
let page = 1

const isSimpleLanguage = store?.isSimpleLanguage ?? false
const site = isSimpleLanguage ? 'de-plain' : 'default'

async function fetchBlogAndCategories() {
  return await useAsyncGql({
    operation: 'BlogAndCategories',
    variables: { limit, page, site: site },
  })
}

blogAndCategories.value = await fetchBlogAndCategories()

hasMorePages.value = blogAndCategories.value.data.entries.has_more_pages

const blog = ref(blogAndCategories.value.data.entries.data)
const filteredBlog = ref(blogAndCategories.value.data.entries.data)
const params = useUrlSearchParams('history')

function filterUpdate(categories) {
  filteredBlog.value = useFilters(categories, blog.value)
}

async function loadMore() {
  page += 1

  let additionalPage = await fetchBlogAndCategories()

  hasMorePages.value = additionalPage.data?.value?.entries.has_more_pages
  additionalPage = additionalPage.data?.value?.entries.data

  if (!Array.isArray(additionalPage) || additionalPage.length === 0) return

  blog.value = blog.value.concat(additionalPage)

  filterUpdate(params.filters)
}

onMounted(() => {
  if (params.filters) {
    filterUpdate([params.filters])
  }
})
</script>
